// Minimal PostHog analytics helper for the app
import posthog from 'posthog-js'

const POSTHOG_KEY = 'phc_QpTrQIJfxyLUQuZ9hX09SSfpF36d5pakBF9Y5R1S7KA'
const POSTHOG_HOST = 'https://tunnel.podcast-generator.ai'

let initialized = false
let identifiedUserId: string | null = null

export function initPostHog() {
  if (initialized || typeof window === 'undefined') return posthog
  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    capture_pageview: false,
    person_profiles: 'always',
    disable_session_recording: false,
  })
  initialized = true;
  return posthog
}

export function track(name: string, properties?: Record<string, unknown>) {
  if (typeof window === 'undefined') return
  posthog.capture(name, properties)
}

export function identify(userId: string, props?: Record<string, unknown>) {
  if (typeof window === 'undefined') return
  if (identifiedUserId === userId) return
  identifiedUserId = userId
  posthog.identify(userId, props)
}

export function pageview(props?: Record<string, unknown>) {
  if (typeof window === 'undefined') return
  posthog.capture('$pageview', { title: document.title, ...props })
}